export default __webpack_public_path__ + "static/media/layered-waves-haikei.6e64c8b7.svg";